define(function(require) {

    /**
	 * static inclues
	 *
	 */
    var self = {};
    var $ = require('jquery');

    var scrollspyNav        = $('.scrollspy')
    var scrollspyNavItems   = $('.scrollspy a, .logo a')
    var isStartseite        = $('body.startseite').length
    var stContainer         = $('.st-container')
    var processing          = false
    
    
    
    /**
	 * public functions
	 *
	 */

    self.processing_scrollIntoView = function (params) {
        /* prevents nav from doing scrollspy while scrollIntoView */
        if (params === 'start') {
            processing = true
            var timer = setTimeout(function(){
                processing = false
            }, 1000);
        } 
        return processing
        
    }


    self.init = function (params) {
        /**
         * click on nav
         */
        if ( isStartseite ) {
            /* scroll to */
            $('.scrollspy a, .logo a, a.pfeil_unten').on('touchstart click', function (e) {
                e.preventDefault()
                var hash = this.hash.substr(1)
                document.getElementById(hash).scrollIntoView({behavior: "smooth", block: "start"})
                history.pushState(null, null, '#'+hash);
                
                stContainer.removeClass('st-menu-open')
                $('.menu-burger').removeClass('close')

                self.processing_scrollIntoView('start')
            });

            /* change nav color */
            scrollspyNavItems.on('touchstart click', function (e) {
                scrollspyNavItems.removeClass('active')
                $(e.currentTarget).addClass('active')
            })
        } else {
            $('a.kontakt, a.pfeil_unten').on('touchstart click', function (e) {
                e.preventDefault()
                var hash = this.hash.substr(1)
                document.getElementById(hash).scrollIntoView({behavior: "smooth", block: "start"})
                // history.pushState(null, null, '#'+hash);
            });
        } 
        
    };


    /**
	 * do stuff
	 *
	 */
    self.init()
    return self;


});


//////////////////
// WEBPACK FOOTER
// ./chunk/nav_anchor.js
// module id = 11
// module chunks = 0